import { useCheckTrad, useTitlePosition } from 'affiny-desktop/src/hooks';
import { Box, rem, Text } from 'affiny-ui/src';
import React, { useRef } from 'react';
import { PersonalityReportLayerTitle } from './PersonalityReportLayerTitle';

interface IPersonalityReportLayerValuesDetailedValue {
  label: string;
  valueId: string;
  children: React.ReactNode;
  setTitle: (title: string) => void;
}

export const PersonalityReportLayerValuesDetailedValue = ({
  label,
  valueId,
  children,
  setTitle,
}: IPersonalityReportLayerValuesDetailedValue) => {
  const titleRef = useRef<HTMLDivElement>(null);

  useTitlePosition({ setTitle, title: valueId, titleRef });

  return (
    <Box margin="0 auto" maxWidth={rem(352)}>
      <Text textAlign="center" fontSize="size14">
        {label}
      </Text>
      <div ref={titleRef}>
        <PersonalityReportLayerTitle
          textAlign="center"
          marginBottom="medium"
          isPrimary
          id={valueId}
        >
          {useCheckTrad(`personalityReport.values.valueLabels.${valueId}`)}
        </PersonalityReportLayerTitle>
      </div>
      {children}
    </Box>
  );
};
